export type HealthTrackerBiometricType = 'weight' | 'blood_pressure';

export interface HealthTrackerProgram {
  id: number;
  title: string;
  biometricType: HealthTrackerBiometricType;
}

/** Tracker types offered in the Browse Trackers flow, in display order. */
export const HEALTH_TRACKER_BIOMETRIC_TYPES: readonly HealthTrackerBiometricType[] = [
  'weight',
  'blood_pressure',
];
